import { Box, DialogContent } from '@mui/material';
import React, { ReactNode } from 'react';
import { Controller, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { ExerciseType as IExerciseType, SimulatorType } from '../../types';
import TypeCard from '../type-card/TypeCard';
import { AdHocExerciseFormData } from './CreateAdHocExerciseDialog';

export type TypeStepProps = UseFormReturn<AdHocExerciseFormData> & {
  actions: ReactNode;
  handleNext: SubmitHandler<AdHocExerciseFormData>;
  stepper: ReactNode;
};

const TypeStep = ({ actions, control, handleNext, handleSubmit, setValue, stepper }: TypeStepProps) => (
  <Box component="form" onSubmit={handleSubmit(handleNext)} sx={{ display: 'contents' }}>
    <DialogContent>
      {stepper}
      <Box display="flex" flexDirection="column" gap={2}>
        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <TypeCard
              adHoc
              exerciseType={IExerciseType.SelfStudy}
              onClick={() => setValue('type', IExerciseType.SelfStudy)}
              selected={field.value === IExerciseType.SelfStudy}
              simulatorType={SimulatorType.Cloud}
            />
          )}
        />
        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <TypeCard
              adHoc
              exerciseType={IExerciseType.Classroom}
              onClick={() => setValue('type', IExerciseType.Classroom)}
              selected={field.value === IExerciseType.Classroom}
              simulatorType={SimulatorType.Site}
            />
          )}
        />
      </Box>
    </DialogContent>

    {actions}
  </Box>
);

export default TypeStep;
